<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card>
          <div class="row align--center">
            <div class="flex md3">
              <va-input
                :value="nomRe"
                :placeholder="$t('poissonnierTable.searchByName')"
                removable
                @input="searchNom"
              >
                <va-icon name="fa fa-search" slot="prepend" />
              </va-input>
            </div>

            <div class="flex md6 offset--md2">
              <div class="row row-inside">
                <va-button-toggle
                  outline
                  class="toggle-activite"
                  v-model="showinactive"
                  :options="options"
                />
                <h5
                  class="selection-nb-title"
                  :style="{ color: this.$themes.primary }"
                >Sélectionnés : {{ filteredDataEntreprise.length }}</h5>
                <va-popover message="Rafraichir" placement="top">
                  <va-button
                    class="selection-refresh"
                    flat
                    large
                    color="primary"
                    icon="fa fa-refresh"
                    @click="getList()"
                  />
                </va-popover>
              </div>
            </div>

            <div class="flex md1">
              <va-input
                class="centered"
                :value="perPage"
                :label="$t('tables.perPage')"
                @input="changePageNumber"
              ></va-input>
            </div>
          </div>
          <va-custom-table
            ref="vadatatable"
            class="va-table--hoverable va-table--stripped custom-table"
            :fields="fields"
            :data="filteredDataEntreprise"
            :no-data-label="$t('poissonnierTable.empty')"
            :per-page="parseInt(perPage)"
            detail-row-component="detail-row-partenaires"
            track-by="idpartenaire"
            @row-clicked="openPartenaire"
            clickable
          >
            <template slot="expend" slot-scope="props">
              <div
                v-if="props.rowData.contacts && props.rowData.contacts.length>0"
                class="flex md12 mx-0 px-0"
                v-on:click="onCellClicked(props.rowData)"
              >
                <va-icon v-if="isVisible(props)" size="20px" name="fa fa-folder-open" />
                <va-icon v-else size="20px" name="fa fa-folder" />
              </div>
            </template>

            <template slot="contact" slot-scope="props">
              <p>{{contactName(props.rowData)}}</p>
            </template>

            <template slot="adresse_cp" slot-scope="props">
              <div class="row row-inside">
                <div class="flex md1 mb-0 pb-0">
                  <va-icon
                    v-show="props.rowData.id!==props.rowData.idadresse"
                    size="10px"
                    name="fa fa-envelope"
                  />
                </div>
                <div class="flex md10 mb-0 pb-0">{{props.rowData.adresse}}</div>
                <div
                  v-if="props.rowData.complement"
                  class="flex md12 mt-0 pt-0 offset--md1"
                >{{props.rowData.complement}}</div>
              </div>
            </template>
            <template slot="note" slot-scope="props">
              <div class="row row-inside comment-div" @click="preventDefaultAction">
                <div
                  v-show="!props.rowData.showModComment"
                  class="flex md12"
                  @click="displayCommentMod(props.rowData)"
                >{{props.rowData.note}}</div>
                <div v-show="props.rowData.showModComment" class="flex md12">
                  <div class="row row-inside">
                    <div class="flex md11">
                      <va-input v-model="props.rowData.commentMod " type="textarea" autosize />
                    </div>
                    <div class="flex md1">
                      <va-button
                        class="button-nm"
                        flat
                        small
                        color="primary"
                        icon="fa fa-save"
                        @click="saveComment(props.rowData)"
                      />
                      <va-button
                        flat
                        class="button-nm"
                        small
                        color="primary"
                        icon="fa fa-close"
                        @click="closeComment(props.rowData)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template slot="journal" slot-scope="props">
              <div class="row row-inside">
                <div class="flex md4">
                  <va-toggle
                    small
                    v-model="props.rowData.subscribed===1"
                    @input="updateJournal(props.rowData)"
                  />
                </div>
                <div class="flex md6">
                  <va-checkbox
                    label="Anonyme"
                    v-model="props.rowData.dirigeant===1"
                    @input="updateHideDirigeant(props.rowData)"
                  />
                </div>
                <v-popover
                  trigger="hover focus"
                  placement="left"
                  :delay="{
                  show: 300,
                  hide: 0
                }"
                >
                  <div class="flex md1" @mouseover="getAdressePartenaires(props.rowData)">
                    <va-icon size="15px" name="fa fa-search" />
                  </div>

                  <template slot="popover">
                    <va-card>
                      <div class="row row-inside" v-for="(adresse, index) in adressesDisplay">
                        <div
                          class="flex md12"
                          v-if="adressesDisplay.length>1"
                        >Adresse {{index + 1}}:</div>
                        <div
                          class="flex md12"
                          v-if="adresse.nomPartenaire"
                        >{{adresse.nomPartenaire}}</div>
                        <div class="flex md12">{{adresse.names}}</div>
                        <div class="flex md12">{{adresse.adresse}}</div>
                        <div class="flex md12" v-if="adresse.complement">{{adresse.complement}}</div>
                        <div
                          class="flex md12"
                        >{{adresse.code_postal}} {{adresse.ville}} {{adresse.cedex}}</div>
                        <div class="flex md12 mb-4" v-if="index<adressesDisplay.length-1">
                          <p></p>
                        </div>
                      </div>
                    </va-card>
                  </template>
                </v-popover>
              </div>
            </template>
          </va-custom-table>
        </va-card>
      </div>
    </div>
    <dashboard-fiche-partenaire
      v-model="showFicheEntreprise"
      :idpartenaire="idpartenaire"
      @update="updatePartenaireFiche"
      @updateContacts="updatePartenaireFiche"
    />
  </div>
</template>

<script>
import axios from "axios";
import DashboardFichePartenaire from "../partenaires/DashboardFichePartenaire";
import vaCustomTable from "./custom-table/VaDataTable";

import {
  cloneDeep,
  find,
  findIndex,
  orderBy,
  isEqual,
  debounce,
  deburr,
} from "lodash";
import moment from "moment";
import EventBus from "../../services/eventBus";

export default {
  components: {
    vaCustomTable,
    DashboardFichePartenaire,
  },
  data() {
    return {
      options: [
        { label: "Toutes", value: "all" },
        { label: "Abonnées", value: "subscribed" },
        { label: "Non abonnées", value: "unsubscribed" },
        { label: "Annonceurs", value: "annonceur" },
      ],
      showinactive: "all",
      nomRe: "",
      isaction: false,
      listEntity: [],
      testEntreprise: null,
      perPage: 10,
      showFicheEntreprise: false,
      idpartenaire: "",
      adressesDisplay: [],
    };
  },
  mounted() {
    EventBus.$on("UPDATE_JOURNAL_PARTENAIRE", (payload) => {
      this.updatePartenaire(payload);
    });

    this.getList();
  },
  methods: {
    async getAdressePartenaires(item) {
      try {
        this.adressesDisplay = [];
        let results = await axios.get("/api/journal/partenaire/adresses", {
          params: { idpartenaire: item.idpartenaire },
        });
        this.adressesDisplay = results.data;
        console.log(this.adressesDisplay);
      } catch (error) {
        console.log(error);
      }
    },
    async updateHideDirigeant(item) {
      console.log(item);
      this.preventDefaultAction();
      try {
        let params = {
          idpartenaire: item.idpartenaire,
          type: "partenaire",
        };

        if (item.dirigeant) {
          // case need to show dirigeant
          params.NotShowDirigeant = false;
        } else {
          //case need to remove dirigeant
          params.NotShowDirigeant = true;
        }
        let value = await axios.post(
          "/api/journal/partenaire/updateShowDirigeant",
          params
        );
        let partenaireInfos = value.data;

        partenaireInfos.showModComment = false;
        partenaireInfos.commentMod = "";
        // update list
        let i = findIndex(this.listEntity, [
          "idpartenaire",
          partenaireInfos.idpartenaire,
        ]);
        //force update on deep change
        ///need to clean the data received
        this.$set(this.listEntity, i, partenaireInfos);
      } catch (error) {}
    },
    isVisible(props) {
      return this.$refs.vadatatable.isVisibleDetailRow(
        props.rowData.idpartenaire
      );
    },
    async saveComment(rowData) {
      this.preventDefaultAction();
      // save comment if change
      if (rowData.note !== rowData.commentMod) {
        let params = {
          idpartenaire: rowData.idpartenaire,
          comment: rowData.commentMod,
        };
        let res = await axios.put(
          "/api/journal/partenaire/save-comment",
          params
        );
        rowData.note = res.data.note;
        rowData.showModComment = false;
        rowData.commentMod = "";
      } else {
        rowData.showModComment = false;
        rowData.commentMod = "";
      }
    },
    closeComment(rowData) {
      this.preventDefaultAction();
      rowData.showModComment = false;
      rowData.commentMod = "";
    },
    displayCommentMod(rowData) {
      this.preventDefaultAction();
      rowData.showModComment = true;
      rowData.commentMod = rowData.note;
    },
    preventDefaultAction() {
      this.isaction = true;
    },

    async updateJournal(item) {
      this.preventDefaultAction();

      // change subscription status

      try {
        let params = {
          idpartenaire: item.idpartenaire,
        };

        if (item.subscribed) {
          // case unsubscribe
          params.date_fin = moment().add(-1, "days").format("YYYY-MM-DD");
        } else {
          //case subscribe
          params.date_fin = "9999-01-01";
        }
        let value = await axios.post("/api/journal/partenaire/update", params);
        let partenaireInfos = value.data;

        // update list
        let i = findIndex(this.listEntity, [
          "idpartenaire",
          partenaireInfos.idpartenaire,
        ]);
        //force update on deep change
        ///need to clean the data received
        this.$set(this.listEntity, i, partenaireInfos);
      } catch (error) {}
      console.log(item);
    },
    async updatePartenaireFiche() {
      try {
        let results = await axios.get("/api/journal/partenaire", {
          params: { idpartenaire: this.idpartenaire },
        });
        this.updatePartenaire(results.data);
      } catch (error) {
        console.log(error);
      }
    },
    updatePartenaire(item) {
      try {
        item.showModComment = false;
        item.commentMod = "";
        // update list
        let i = findIndex(this.listEntity, ["idpartenaire", item.idpartenaire]);
        //force update on deep change
        ///need to clean the data received
        this.$set(this.listEntity, i, item);
      } catch (error) {
        console.log(error);
      }
    },
    searchNom: debounce(function (nomRe) {
      this.nomRe = nomRe;
    }, 400),
    changePageNumber: debounce(function (perPage) {
      if (!perPage) {
        this.perPage = "6";
      } else {
        var n = Math.floor(Number(perPage));
        if (n !== Infinity && String(n) === perPage && n >= 0) {
          this.perPage = perPage;
        } else {
          this.perPage = "6";
        }
      }
    }, 400),
    contactString(titre, nom, prenom) {
      let contactString = "";
      if (titre) {
        contactString = titre[0].toUpperCase() + titre.slice(1).toLowerCase();
      }

      if (nom) {
        contactString = contactString ? contactString + " " : "";
        contactString += nom.toUpperCase();
      }
      if (prenom) {
        contactString = contactString ? contactString + " " : "";
        contactString +=
          prenom[0].toUpperCase() + prenom.slice(1).toLowerCase();
      }

      return contactString;
    },
    contactName(rowData) {
      try {
        let contact = find(rowData.contacts, {
          idcontacts_partenaire: rowData.idcontact,
        });

        if (!contact) {
          return;
        }
        // deal with the dirigeant being a société
        if (contact.titre && contact.titre === "SOCIÉTÉ") {
          return this.contactString(
            contact.titre_societe,
            contact.nom_societe,
            contact.prenom_societe
          );
        } else {
          return this.contactString(contact.titre, contact.nom, contact.prenom);
        }
      } catch (error) {
        console.log(error);
        console.log("error retrieving the contact");
        return "";
      }
    },

    onCellClicked(data) {
      this.isaction = true;
      this.$refs.vadatatable.openRow(data.idpartenaire);
      console.log("cellClicked: ", data);
    },
    openPartenaire(partenaire) {
      if (this.isaction) {
        this.isaction = false;
        return;
      } else {
        this.showFicheEntreprise = true;
        this.idpartenaire = partenaire.idpartenaire;
      }
    },
    async getList() {
      try {
        let results = await axios.get("/api/journal/partenaires/list");

        results.data.forEach((element) => {
          element.showModComment = false;
          element.commentMod = "";
        });

        this.listEntity = results.data;
      } catch (error) {
        console.log(error);
      }
    },
    isSubscribed(item) {
      let isSubscribed = false;
      isSubscribed =
        item.date_fin && moment(item.date_fin, "YYYY-MM-DD").isAfter(moment())
          ? true
          : isSubscribed;
      if (item.contacts) {
        for (var ijk = 0; ijk < item.contacts.length; ijk++) {
          isSubscribed =
            item.contacts[ijk].date_fin &&
            moment(item.contacts[ijk].date_fin, "YYYY-MM-DD").isAfter(moment())
              ? true
              : isSubscribed;
        }
      }
      return isSubscribed;
    },
  },
  computed: {
    filteredDataEntreprise() {
      let filteredData = this.listEntity;
      return filteredData.filter((item) => {
        let boolcond = true;

        if (this.showinactive === "annonceur") {
          boolcond = item.annonceur ? boolcond : false;
        }

        if (this.showinactive === "subscribed") {
          boolcond = boolcond && this.isSubscribed(item);
        }

        if (this.showinactive === "unsubscribed") {
          boolcond = boolcond && !this.isSubscribed(item);
        }
        try {
          if (this.nomRe && this.nomRe.length >= 1) {
            let isIn = false;
            let nomCpre = deburr(this.nomRe).toLowerCase();
            isIn =
              deburr(item.nom).toLowerCase().includes(nomCpre) ||
              (item.telephone && item.telephone.includes(nomCpre)) ||
              (item.portable && item.portable.includes(nomCpre)) ||
              (item.code_postal && item.code_postal.includes(nomCpre)) ||
              deburr(item.ville).toLowerCase().includes(nomCpre) ||
              deburr(item.email).toLowerCase().includes(nomCpre);

            if (item.contacts) {
              for (var ijk = 0; ijk < item.contacts.length; ijk++) {
                let contact = item.contacts[ijk];
                isIn =
                  isIn ||
                  deburr(contact.nom).toLowerCase().includes(nomCpre) ||
                  deburr(contact.prenom).toLowerCase().includes(nomCpre) ||
                  (contact.telephone && contact.telephone.includes(nomCpre)) ||
                  (contact.portable && contact.portable.includes(nomCpre)) ||
                  deburr(contact.email).toLowerCase().includes(nomCpre);
              }
            }
            boolcond = isIn && boolcond;
          }
        } catch (error) {
          console.log("test", item);
        }
        return boolcond;
      });
    },
    fields() {
      return [
        { name: "__slot:expend", width: "3%" },
        {
          name: "nom",
          title: "Société",
          sortField: "nom",
          width: "14%",
        },
        {
          name: "__slot:contact",
          title: "Contact",
          width: "17%",
        },
        {
          name: "__slot:adresse_cp",
          title: "Adresse",
          width: "16%",
        },
        {
          name: "code_postal",
          title: "Code Postal",
          sortField: "code_postal",
          width: "8%",
        },
        {
          name: "ville",
          title: "Ville",
          sortField: "ville",
          width: "8%",
        },
        {
          name: "__slot:note",
          title: "Note",
          width: "17%",
        },
        {
          name: "__slot:journal",
          title: "Journal",
          width: "17%",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-table {
  font-size: 1rem;
  line-height: 1rem;
}

.selection-nb-title {
  position: relative;
  top: 0.8em;
}

.comment-div {
  width: 100%;
  min-height: 3em;
}

.button-nm {
  margin: 0;
}
</style>
